import { OnChangeParams } from 'baseui/select';
import { useMemo } from 'react';
import { FLEET_SERVICE_STATUS_OPTIONS } from '../../../constants/fleet';
import { FleetServiceStatus } from '../../../types/fleet';
import { EnhancedLabeledSelect } from '../../ui/EnhancedLabeledSelect';

type Props = {
  selectedId?: FleetServiceStatus;
  onChangeId?: (id?: FleetServiceStatus) => void;
  isFilter?: boolean;
  label?: string;
  emptyOptionText?: string;
  showEmptyOption?: boolean;
  error?: React.ReactNode;
  onBlur?: () => void;
  inline?: boolean;
  clearable?: boolean;
  required?: boolean;
  disabled?: boolean;
  selectMaxWidth?: number;
};

function FleetServiceStatusSelect({
  selectedId,
  onChangeId,
  isFilter = true,
  label = 'Estatus:',
  emptyOptionText = 'Seleciona un estatus',
  showEmptyOption = false,
  error,
  onBlur,
  inline,
  clearable = false,
  required = false,
  disabled = false,
  selectMaxWidth,
}: Readonly<Props>) {
  const serviceStatusOptions = useMemo(() => {
    const coreOptions = FLEET_SERVICE_STATUS_OPTIONS;
    const options = showEmptyOption
      ? [
          {
            id: undefined,
            label: isFilter ? 'Todos' : emptyOptionText,
          },
          ...coreOptions,
        ]
      : coreOptions;
    return options;
  }, []);

  const onSelectedChange = (params: OnChangeParams) => {
    if (params.option?.id) {
      onChangeId && onChangeId(params.option.id as FleetServiceStatus);
    } else {
      onChangeId && onChangeId(undefined);
    }
  };

  return (
    <EnhancedLabeledSelect
      label={label}
      options={serviceStatusOptions}
      value={showEmptyOption || selectedId !== undefined ? [{ id: selectedId }] : undefined}
      onChange={onSelectedChange}
      fullWidth
      onBlur={() => {
        onBlur && onBlur();
      }}
      searchable
      inline={inline}
      inset={inline}
      error={error}
      required={required}
      clearable={clearable}
      placeholder={emptyOptionText}
      disabled={disabled}
      selectMaxWidth={selectMaxWidth}
    />
  );
}

export default FleetServiceStatusSelect;
